import { AppNS } from 'app';
import { ApiCollectionResponse } from 'app/api';
import { Params } from 'app/types';

import { request } from '../config';

const URL = 'qa-reports';

export function apiGetReports(
  data: Params,
  subject: string | null,
  signal?: AbortSignal
): Promise<ApiCollectionResponse<AppNS.QaReport>> {
  return request(
    {
      url: `${URL}.json`,
      method: 'GET',
      params: { ...data, ...(subject && { subject }) },
      signal,
    },
    (data) => data.models
  );
}

export function apiGetReportById(id: string, signal?: AbortSignal): Promise<AppNS.QaReport> {
  return request(
    {
      url: `${URL}/${id}.json`,
      method: 'GET',
      signal,
    },
    (data) => data.model
  );
}

export function apiCreateReport(data: Partial<AppNS.QaReport>): Promise<AppNS.QaReport> {
  return request(
    {
      url: `${URL}.json`,
      method: 'POST',
      data: { qa_reports: data },
    },
    (data) => data.model
  );
}

export function apiUpdateReport(id: string, data: Params): Promise<AppNS.QaReport> {
  return request(
    {
      url: `${URL}/${id}.json`,
      method: 'PATCH',
      data,
    },
    (data) => data.model
  );
}

export function apiGetReportsForInspections(
  eventReportIds: string[],
  signal?: AbortSignal
): Promise<ApiCollectionResponse<AppNS.QaReport>> {
  return request(
    {
      url: `${URL}.json`,
      method: 'GET',
      params: { type: 'join', eventReportIds },
      signal,
    },
    (data) => data.models
  );
}
